/* newsletter-popup.js — popup email 5% (sections/newsletter-popup.liquid). 03/10/2026, chu shop chot.
   Luat hien: PC sau N giay (mac dinh 20) VA cuon >= 50% — hoac chuot roi len mep tren (dinh thoat) sau toi thieu 8s;
   mobile sau N giay (mac dinh 25) VA cuon >= 35%. Moi phien toi da 1 lan. Dong -> sau N ngay (7) moi hien lai.
   Da dang ky -> khong bao gio hien, khong tab. Tab "5% OFF" chi hien SAU KHI khach dong popup; X tab -> an tab N ngay.
   Cho (khong hien) khi: panel Customise dang mo, khach vua thao tac chon option < 10s, gio keo dang mo.
   Trang thai: localStorage "xl-npop" = { dong: ms, dk: 1, tabAn: ms }; phien: sessionStorage "xl-npop-phien".
   Moi truy cap storage boc try/catch — loi thi coi nhu chua xem. */
(function () {
  var goc = document.querySelector('[data-npop]');
  if (!goc || goc.__npop) return;
  goc.__npop = true;
  var hop = goc.querySelector('.npop__box');
  var tab = document.getElementById(goc.id + '-tab');
  var NGAY = (parseInt(goc.dataset.ngay, 10) || 7) * 864e5;
  var mb = window.matchMedia('(max-width: 749px)');
  var KHOA = 'xl-npop';

  function doc() { try { return JSON.parse(localStorage.getItem(KHOA) || '{}') || {}; } catch (e) { return {}; } }
  function ghi(o) { try { var t = doc(); for (var k in o) t[k] = o[k]; localStorage.setItem(KHOA, JSON.stringify(t)); } catch (e) {} }
  function phien(v) { try { if (v === undefined) return sessionStorage.getItem('xl-npop-phien'); sessionStorage.setItem('xl-npop-phien', v); } catch (e) { return null; } }
  function guiTuPopup(v) { try { if (v === undefined) return sessionStorage.getItem('xl-npop-gui'); if (v) sessionStorage.setItem('xl-npop-gui', '1'); else sessionStorage.removeItem('xl-npop-gui'); } catch (e) { return null; } }

  /* ---- mo / dong ---- */
  var truocDo = null;
  function napAnh() {
    var a = goc.querySelector('.npop__anh img[data-src-pc]');
    if (!a || a.getAttribute('src')) return;
    a.src = mb.matches ? a.dataset.srcMb : a.dataset.srcPc;
  }
  function mo(oDau) {
    napAnh();
    truocDo = document.activeElement;
    goc.classList.add('is-mo');
    document.documentElement.style.overflow = 'hidden';
    phien('1');
    var f = goc.querySelector(oDau || '.npop__field') || goc.querySelector('.npop__btn, [data-npop-dong]');
    setTimeout(function () { if (f) f.focus({ preventScroll: true }); }, 30);
  }
  function dong(boQua) {
    if (!goc.classList.contains('is-mo')) return;
    goc.classList.remove('is-mo');
    document.documentElement.style.overflow = '';
    if (!boQua) {
      var t = doc();
      if (!t.dk) { ghi({ dong: Date.now() }); hienTab(); }
    }
    if (truocDo && truocDo.focus) truocDo.focus({ preventScroll: true });
  }
  function hienTab() {
    if (!tab) return;
    var t = doc();
    var an = t.dk || (t.tabAn && Date.now() - t.tabAn < NGAY) || !t.dong;
    tab.classList.toggle('is-hien', !an);
  }

  goc.addEventListener('click', function (e) {
    if (e.target === goc || e.target.closest('[data-npop-dong]')) { e.preventDefault(); dong(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!goc.classList.contains('is-mo')) return;
    if (e.key === 'Escape') { dong(); return; }
    if (e.key !== 'Tab') return;
    var ds = [].slice.call(hop.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden])')).filter(function (x) { return x.offsetParent; });
    if (!ds.length) return;
    var dau = ds[0], cuoi = ds[ds.length - 1];
    if (e.shiftKey && document.activeElement === dau) { e.preventDefault(); cuoi.focus(); }
    else if (!e.shiftKey && document.activeElement === cuoi) { e.preventDefault(); dau.focus(); }
  });
  if (tab) {
    tab.addEventListener('click', function (e) {
      if (e.target.closest('[data-npop-an-tab]')) { ghi({ tabAn: Date.now() }); tab.classList.remove('is-hien'); return; }
      if (e.target.closest('[data-npop-mo]')) { tab.classList.remove('is-hien'); mo(); }
    });
  }
  /* nut Copy ma */
  var chep = goc.querySelector('[data-npop-chep]');
  if (chep) chep.addEventListener('click', function () {
    var ma = (goc.querySelector('[data-npop-ma]') || {}).textContent || '';
    var xong = function () { chep.textContent = 'Copied'; setTimeout(function () { chep.textContent = 'Copy'; }, 2000); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(ma.trim()).then(xong, function () { thuCu(ma); xong(); });
    else { thuCu(ma); xong(); }
  });
  function thuCu(ma) { var t = document.createElement('textarea'); t.value = ma.trim(); t.style.position = 'fixed'; t.style.opacity = '0'; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} t.remove(); }
  /* gui form: danh dau de trang sau biet ket qua la cua popup (khong phai form email o footer) */
  var form = goc.querySelector('form');
  if (form) form.addEventListener('submit', function () { guiTuPopup(true); });

  /* ---- trang vua tai lai sau khi gui ---- */
  var guiPopup = guiTuPopup() === '1' || location.hash.indexOf(goc.dataset.formId) > -1;
  if (goc.dataset.xong === 'true') {
    ghi({ dk: 1 });
    if (tab) tab.classList.remove('is-hien');
    guiTuPopup(false);
    if (guiPopup) mo('.npop__chep');
    return;
  }
  if (goc.dataset.loi === 'true' && guiPopup) { guiTuPopup(false); mo(); return; }
  guiTuPopup(false);

  /* ---- luat tu mo ---- */
  var t0 = doc();
  if (goc.dataset.an === 'true' || t0.dk) return;
  hienTab();
  if (t0.dong && Date.now() - t0.dong < NGAY) return;
  if (phien()) return;

  var batDau = Date.now();
  var lanCuoiChon = 0;
  document.addEventListener('change', danhDau, true);
  document.addEventListener('input', danhDau, true);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.cstrap-section, .jsc-mto__panel')) lanCuoiChon = Date.now(); }, true);
  function danhDau(e) { if (e.target.closest && e.target.closest('.cstrap-section, .jsc-mto__panel, product-form, variant-selects')) lanCuoiChon = Date.now(); }
  function ban() {
    if (document.querySelector('.jsc-mto__panel.is-mo')) return true;
    if (document.querySelector('cart-drawer.active, .drawer.active')) return true;
    if (document.querySelector('[role="dialog"][open], details[open] > .modal, .menu-drawer-container[open]')) return true;
    if (lanCuoiChon && Date.now() - lanCuoiChon < 10000) return true;
    return false;
  }
  function daCuon() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return 1;
    return window.scrollY / h;
  }
  var choGiay = (mb.matches ? parseInt(goc.dataset.choMb, 10) || 25 : parseInt(goc.dataset.choPc, 10) || 20) * 1000;
  var nguong = mb.matches ? 0.35 : 0.5;
  var daMo = false;
  function thu(lyDo) {
    if (daMo || phien()) return;
    if (ban()) return;
    daMo = true;
    clearInterval(dongHo);
    mo();
  }
  var dongHo = setInterval(function () {
    if (Date.now() - batDau >= choGiay && daCuon() >= nguong) thu('thoi-gian');
  }, 1000);
  /* PC: chuot roi len mep tren cua so (dinh thoat), sau toi thieu 8 giay */
  if (!mb.matches) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 0) return;
      if (Date.now() - batDau < 8000) return;
      thu('thoat');
    });
  }
})();
